<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h"><span><i>Book One:</i></span></p>
<p class="part-left"><i>If this valley is lost, Virginia is lost</i>.</p>
<p class="part-right"><span>—<span class="smallcaps">JACKSON</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?1ee55195